<div id="ach-r-contact-support">
  <div class="main_profile">
    <div class="modal-header switch_header">
      <ng-container>
        <div class="col-lg-12 col-xl-12 col-12" >
          <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
            Contact PayArc Support
          </h3>
        </div>
      </ng-container>
    </div>
    <div class="modal-body bg-white body-content" >
      <ng-container>
        <div class="row">
          <div class="col-lg-12 col-xl-12 col-12" >
            <h3 class="profile_body pl-lg-2 pt-lg-2 pb-2 offset-0">
              <form [formGroup]="sendSupport" #send_support="ngForm" class="form-group">
              <div class="form-group row padding-m">
                <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Subject:</label>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <input class="form-control" formControlName="merchant_subject" type="text" value="" name="subject" id="subject" title="ACH Rejects Inquiry for"/>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_subject'].errors?.required">
                    * Subject is Required</span>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_subject'].errors?.minlength && sendSupport.controls['merchant_subject'].touched">
                    * Subject min length is 3
                  </span>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_subject'].errors?.maxlength && sendSupport.controls['merchant_subject'].touched">
                    * Subject max length is 50
                  </span>
                </div>
              </div>
              <div class="form-group row padding-m">
                <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Reply-To:</label>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <input class="form-control" formControlName="merchant_email" type="text" value="" name="subject" id="reply-to" title="Reply To"/>
                </div>
              </div>
              <div class="form-group row padding-m">
                <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Body:</label>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <textarea  class="form-control" formControlName="merchant_body" name="body" rows="4" cols="50" id="body" title="Reply To">
                  </textarea>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_body'].errors?.required && sendSupport.controls['merchant_body'].touched">
                    * Body is required
                  </span>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_body'].errors?.minlength && sendSupport.controls['merchant_body'].touched">
                    * Body min length is 10
                  </span>
                  <span class="end_after_error" *ngIf="sendSupport.controls['merchant_body'].errors?.maxlength && sendSupport.controls['merchant_body'].touched">
                    * Body max length is 500
                  </span>
                </div>
              </div>
              </form>
            </h3>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="p-0">
      <div class="dropdown-footer">
        <div class="row">
          <div class="col-sm-4 col-6 pl-xl-4 pl-lg-4 offset-4">
            <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()" >Cancel</button>
          </div>
          <div class="col-sm-4 col-6">
            <button class="btn btn-default lg-btn ok-btn" (click)=" runAction()" >Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
